export const APP_EMAILS = {
  EVENTS: 'events@unifyamerica.org',
} as const;

export const UNIFY_AMERICA_URLS = {
  CIVIC_GYM: 'https://www.unifyamerica.org/civic-gym',
  PRIVACY_POLICY: 'https://www.unifyamerica.org/policy/privacy',
  DATA_SECURITY: 'https://www.unifyamerica.org/policy/data-security',
  TERMS_OF_SERVICE: 'https://www.unifyamerica.org/policy/terms-of-service',
  RECORDING_RELEASE: 'https://www.unifyamerica.org/recording-release',
} as const;